import React from 'react';
import exportDocsLogo from '../../../assets/exportDocsLogo512.png';
const AccountPageShowBrand = () => {
    return (
        <span >
            <img src={exportDocsLogo} height={100} />
        </span>
    );
}
export default AccountPageShowBrand